import { Component, inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { getDisplayedPages } from 'src/app/lib/pagination';
import { toFixed } from 'src/app/lib/roundOf';
import { ExportService } from 'src/app/services/export-service.service';
import { SpotService } from 'src/app/services/spot.service';
import { PairFacade } from 'src/app/store/botpair';

@Component({
  selector: 'app-open-order-history',
  templateUrl: './open-order-history.component.html',
  styleUrls: ['./open-order-history.component.css']
})
export class OpenOrderHistoryComponent {


  private readonly pairFacade: PairFacade = inject(PairFacade);
  form: FormGroup;
  searchForm:FormGroup;
  pairList: any = []
  loading: boolean = false;

  toFixed = toFixed
  orderHistory: any = []
  filter: any = {
    page: 1,
    limit: 10,
    totalPages: 0,
    pairName: "all",
    orderType: "all",
    buyorsell: "all",
    status: "all"
  }

  // paginator: number[] = []
  getDisplayedPages: number[] = []
  displayedColumns = {
    label: [
      'Pair',
      'Order Date',
      'Trade Type',
      'Price',
      'Quantity',
      'Filled_Remaining',
      'Side',
      'Status'
    ],
    cols: [
      'pairName',
      'orderDate',
      'orderType',
      'price',
      'quantity',
      'Filled_Remaining',
      'buyorsell',
      'status'
    ]
  };
  
  constructor(private service: SpotService, private _fb: FormBuilder,private exportService:ExportService) {
    this.form = this._fb.group({
      pairName: "all",
      buyorsell: "all",
      status: "all",
      orderType: "all"
    });
    this.searchForm = this._fb.group({
      fromDate: [''],
      toDate: ['']
    });
  }

  ngOnInit() {
    this.fetchOrderHistory(this.filter);
    this.getPairList()
  }

  getPairList() {
    this.service.getPairList().subscribe({
      next: (v: any) => {
        if (v.success) {
          this.pairFacade.setPair(v.result);
          this.pairList = v.result;
        }
      },
      error: (err: any) => { },
    });
  }

  downloadExcel() {
    this.loading=true;
  this.filter.limit=10000000000;
    this.fetchOrderHistory(this.filter);

    setTimeout(() => {
  const modifiedData = (this.orderHistory || []).map((item: any) => ({
    ...item,
    Filled_Remaining: `${item.filledQuantity} / ${item.openQuantity - item.filledQuantity}`
  }));

      const req = {
        ...this.displayedColumns,
        data: modifiedData,
        filename: 'Order History',
        BotServicedateField: ['updatedAt']
      };
      this.exportService.exportExcel(req);
    }, 2000);
    this.loading = true;

  }
  viewAllData(){
this.filter.limit=100000000;
    this.fetchOrderHistory(this.filter);

  }
  fetchOrderHistory(filter: any) {
    this.filter.limit=100000000;
    this.service.gethistoryOrderhistory(filter).subscribe({
      next: (data: any) => {
  const allOrders = data.result.data || []; // Access the correct array

      // Filter only 'open' and 'pending' status
      const filteredOrders = allOrders.filter((order: any) =>
        order.status === 'open' || order.status === 'pending'
      );

      this.orderHistory = filteredOrders;

      // Use filtered count, not original
      const count = filteredOrders.length;
      this.filter.totalPages = Math.ceil(count / this.filter.limit);
      this.getDisplayedPages = getDisplayedPages(this.filter.page, this.filter.totalPages, 5);
    },
    error: () => {
      console.error('Failed to fetch order history');
    }
  });
}

  nextPage() {
    this.filter.page += 1

    this.fetchOrderHistory(this.filter);
  }

  goToPage(pageNo: number) {
    this.filter.page = pageNo
    this.fetchOrderHistory(this.filter);
  }

  previousPage() {
    if (this.filter.page > 1)
      this.filter.page -= 1

    this.fetchOrderHistory(this.filter);
  }

  onOptionChange(event: any) {
    const name = event.target.id
    const filterValue = event.target.value
    this.filter[name] = filterValue

  }

  searchfilter() {
    this.filter.page = 1;
    this.filter.limit = 100000;
    this.fetchOrderHistory(this.filter);
    const { fromDate, toDate } = this.searchForm.value;
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
  
    // Wait a bit before filtering to ensure data is fetched
    setTimeout(() => {
      if (this.orderHistory?.data && Array.isArray(this.orderHistory.data)) {
        const { fromDate, toDate } = this.searchForm.value;
      
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;
      
        this.orderHistory.data = this.orderHistory.data.filter((item: { createdAt: string }) => {
          const createdAt = new Date(item.createdAt);
      
          const createdDateOnly = new Date(createdAt.toDateString());
          const fromDateOnly = from ? new Date(from.toDateString()) : null;
          const toDateOnly = to ? new Date(to.toDateString()) : null;
      
          if (fromDateOnly && toDateOnly) {
            return createdDateOnly >= fromDateOnly && createdDateOnly <= toDateOnly;
          } else if (fromDateOnly) {
            return createdDateOnly >= fromDateOnly;
          } else if (toDateOnly) {
            return createdDateOnly <= toDateOnly;
          }
          return true;
        });
      }
      
    }, 300); // Adjust delay as needed
  }
  

  clearfilter() {
    const initialfilter = {
      page: 1,
      limit: 10,
      totalPages: 0,
      pairName: "all",
      orderType: "all",
      buyorsell: "all",
      status: "all"
    }
    // this.filter.page = 1
    this.form.reset()
    this.form.patchValue({
      pairName: "all",
      buyorsell: "all",
      orderType: "all",
      status: "all"

    })
    this.fetchOrderHistory(initialfilter);
    this.filter = initialfilter
  }


}

